// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6992 ? "be74e82d" : chunkId) + "." + {"6992":"4e2ec7ed08e887a8","8162":"b4aa44cf1b443311"}[chunkId] + ".js";
};